import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { defaultLang } from "./config-lang";
// import translationEn from "./langs/en.json";
import translationFr from "./langs/fr.json";
import translationVi from "./langs/vi.json";
import translationCn from "./langs/cn.json";
import translationAr from "./langs/ar.json";
import translationTr from "./langs/tr";
import translationEn from "./langs/en";
import { localStorageGetItem } from "../utils/storage-available";


const lng = localStorageGetItem("i18nextLng", defaultLang.value);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translations: translationTr },
      en: { translations: translationEn },
      fr: { translations: translationFr },
      vi: { translations: translationVi },
      cn: { translations: translationCn },
      ar: { translations: translationAr },
    },
    lng,
    fallbackLng: "en",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
